import { Component, input } from '@angular/core';

export interface TileModel {
  headline: string;
  icon?: string;
  text: string;
  backgroundUrl?: string;
}

@Component({
  selector: 'customer-app-equity-tile-item',
  templateUrl: './equity-tile-item.component.html',
  styleUrls: ['./equity-tile-item.component.scss'],
  standalone: false
})
export class EquityTileItemComponent {
  readonly tile = input<TileModel>(undefined);
}
